/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useContext } from 'react';

import { ArticleContext } from '../../Article.context';
import { VirtualCaption } from './Caption';
import styles from '../../article.module.css';
import { useShowComponent, Devices } from '../VirtualArticle.hooks';
import { VirtualArticleContext } from '../VirtualArticleContext';

export const VirtualAdvert = (props: StyledAdvertProps) => {
	let { caption, width, credit } = props;
	const {
		id,
		fullwidth,
		align,
		expandfullwidth,
		bleed,
		imagelink,
		captionposition,
		captionenabled,
		fixedwidth,
		creditenabled,
		imageurl,
		imageclip,
		linktype,
		advertlink,
		onClick,
		devices,
	} = props;
	const { onContentProtection, contentProtection } = useContext(
		VirtualArticleContext,
	);
	const { lang, style } = useContext(ArticleContext);
	if (typeof caption === 'object') {
		caption = caption[lang] ? caption[lang] : '';
	}
	if (typeof credit === 'object') {
		credit = credit[lang] ? credit[lang] : '';
	}

	if (typeof width === 'string') {
		width = parseInt(width);
	}

	let marginBottom = 0;
	if (style?.canvas?.componentBottomMargin) {
		marginBottom = parseInt(`${style['canvas']?.componentBottomMargin}`);
	}

	const creditValue = credit
		? typeof credit === 'string'
			? credit
			: credit[lang]
		: '';

	return (
		<Advert
			id={id}
			onClick={onClick}
			align={align}
			bleed={bleed === 'on'}
			fullWidth={fullwidth === 'on'}
			expandFullWidth={expandfullwidth === 'on'}
			caption={caption}
			imageClip={imageclip}
			onContentProtection={
				contentProtection ? onContentProtection : undefined
			}
			captionEnabled={captionenabled === 'on'}
			credit={creditValue}
			creditEnabled={creditenabled === 'on'}
			link={imagelink}
			width={width}
			captionPosition={captionposition}
			url={imageurl}
			linkType={linktype}
			advertLink={advertlink}
			marginBottom={marginBottom}
			fixedWidth={fixedwidth === 'on'}
			devices={devices}
		/>
	);
};

interface StyledAdvertProps {
	id: string;
	align: string;
	bleed: string;
	fullwidth: string;
	expandfullwidth: string;
	caption: string | any;
	captionenabled: string;
	captionposition: string;
	credit: string | any;
	creditenabled: string;
	width: string | number;
	fixedwidth: string;
	imagelink: string;
	advertlink: string;
	imageurl: string;
	imageClip: string;
	linktype: string;
	devices: Devices;
	imageclip: string;
	onClick: any;
}

export const Advert = (props: AdvertProps) => {
	let { bleed, fullWidth } = props;
	const {
		id,
		align,
		expandFullWidth,
		caption,
		captionEnabled = true,
		credit,
		creditEnabled = true,
		width,
		fixedWidth,
		link,
		url,
		imageClip,
		marginBottom = 0,
		linkType,
		advertLink,
		onClick,
		devices,
		onContentProtection,
	} = props;
	const showClassNames = useShowComponent(devices);
	const { navigateToArticle } = useContext(VirtualArticleContext);
	const articleContext = useContext(ArticleContext);
	const containerStyle: any = {
		marginBottom,
	};
	let imageStyle: any = {};

	containerStyle.alignItems = getAlignment(align);

	if (expandFullWidth) {
		bleed = true;
		fullWidth = false;
	}

	/*if (bleed && !fullWidth) {
		containerStyle.marginLeft = `-${paddingLeft}`;
		containerStyle.marginRight = `-${paddingRight}`;
	}*/

	if (fullWidth) {
		containerStyle.minWidth = '100%';
		containerStyle.width = '100%';
	}

	if (expandFullWidth) {
		imageStyle.minWidth = '100%';
		imageStyle.width = '100%';
	}

	if (fixedWidth && width) {
		imageStyle = {
			maxWidth: width,
		};
	}

	imageStyle.clipPath = getClipPath(imageClip);

	let click = () => {};

	const classNames = [
		'component',
		styles['component'],
		'media',
		styles['image'],
		styles['advert'],
		showClassNames,
	];
	if (bleed && !fullWidth) {
		classNames.push('bleed');
	}

	const onOpenWindow = () => {
		window.open(link);
	};

	if (linkType === 'web' && link && isValidUrl(link)) {
		containerStyle.cursor = 'pointer';
		imageStyle.cursor = 'pointer';
		return (
			<figure
				id={id}
				className={classNames.join(' ')}
				style={containerStyle}
			>
				{onContentProtection ? (
					<img
						src={`${url.replace(/\\/g, '/')}`}
						width={articleContext.width}
						height={400}
						alt={caption || ''}
						style={imageStyle}
						className="content-protection"
						onContextMenu={onContentProtection}
						onKeyDown={onOpenWindow}
						onClick={onOpenWindow}
					/>
				) : (
					<img
						src={`${url.replace(/\\/g, '/')}`}
						width={articleContext.width}
						height={400}
						alt={caption || ''}
						style={imageStyle}
						onKeyDown={onOpenWindow}
						onClick={onOpenWindow}
					/>
				)}

				{captionEnabled && caption ? (
					<VirtualCaption content={caption} />
				) : null}
				{creditEnabled && credit ? <Credit content={credit} /> : null}
			</figure>
		);
	}

	if (
		linkType === 'page' &&
		advertLink &&
		/\/article\/([0-9]*)/gim.test(advertLink)
	) {
		click = () => {
			const articleReg = /\/article\/([0-9]*)/;
			if (!articleReg.test(advertLink)) {
				return;
			}
			if (!navigateToArticle) {
				return;
			}
			const matches = articleReg.exec(advertLink);
			if (matches === null) {
				return;
			}
			const articleId = matches[1];
			navigateToArticle(parseInt(`${articleId}`, 10));
		};
		containerStyle.cursor = 'pointer';
		imageStyle.cursor = 'pointer';
		return (
			<figure
				id={id}
				className={classNames.join(' ')}
				style={containerStyle}
				onClick={click}
				onKeyDown={click}
			>
				{onContentProtection ? (
					<img
						src={`${url.replace(/\\/g, '/')}`}
						width={articleContext.width}
						height={400}
						className="content-protection"
						alt={caption || ''}
						style={imageStyle}
						onContextMenu={onContentProtection}
					/>
				) : (
					<img
						src={`${url.replace(/\\/g, '/')}`}
						width={articleContext.width}
						height={400}
						alt={caption || ''}
						style={imageStyle}
					/>
				)}

				{captionEnabled && caption ? (
					<VirtualCaption content={caption} />
				) : null}
				{creditEnabled && credit ? <Credit content={credit} /> : null}
			</figure>
		);
	}

	if (onClick) {
		containerStyle.cursor = 'pointer';
		click = onClick;
	}

	return (
		<figure
			id={id}
			className={classNames.join(' ')}
			style={containerStyle}
			onKeyDown={click}
			onClick={click}
		>
			{onContentProtection ? (
				<img
					src={`${url.replace(/\\/g, '/')}`}
					width={articleContext.width}
					height={400}
					className="content-protection"
					alt={caption || ''}
					style={imageStyle}
					onContextMenu={onContentProtection}
				/>
			) : (
				<img
					src={`${url.replace(/\\/g, '/')}`}
					width={articleContext.width}
					height={400}
					alt={caption || ''}
					style={imageStyle}
				/>
			)}

			{captionEnabled && caption ? (
				<VirtualCaption content={caption} />
			) : null}
			{creditEnabled && credit ? <Credit content={credit} /> : null}
		</figure>
	);
};

interface AdvertProps {
	id: string;
	align: string;
	bleed: boolean;
	fullWidth: boolean;
	expandFullWidth: boolean;
	caption: string | any;
	captionEnabled: boolean;
	captionPosition: any;
	credit: string;
	devices: Devices;
	creditEnabled: boolean;
	width: number | string | any;
	fixedWidth: boolean;
	link: string;
	advertLink: string;
	url: string;
	imageClip: string;
	linkType: string;
	marginBottom: number;
	onClick: any;
	onContentProtection?: (
		e: React.MouseEvent<HTMLImageElement, MouseEvent>,
	) => void;
}

function getClipPath(imageClip: string) {
	switch (imageClip) {
		case 'circle':
			return 'circle(50% at 50% 50%)';
		case 'ellipse':
			return 'ellipse(25% 40% at 50% 50%)';
		case 'triangle':
			return 'polygon(50% 0%, 0% 100%, 100% 100%)';
		case 'trapezoid':
			return 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)';
		case 'parallelogram':
			return 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)';
		case 'rhombus':
			return 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)';
		case 'pentagon':
			return 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)';
		case 'hexagon':
			return 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)';
		case 'heptagon':
			return 'polygon(50% 0%,90% 20%, 100% 60%,75% 100%, 25% 100%,0% 60%,10% 20%)';
		case 'octagon':
			return 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)';
		case 'nonagon':
			return 'polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%)';
		case 'decogon':
			return 'polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%)';
		case 'bevel':
			return 'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)';
		case 'rabbet':
			return 'polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%)';
		case 'leftarrow':
			return 'polygon(40% 0%, 40% 20%, 100% 20%, 100% 80%, 40% 80%, 40% 100%, 0% 50%)';
		case 'rightarrow':
			return 'polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)';
		case 'leftpoint':
			return 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)';
		case 'rightpoint':
			return 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)';
		case 'rightchevron':
			return 'polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)';
		case 'leftchevron':
			return 'polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)';
		case 'star':
			return 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)';
		case 'close':
			return 'polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)';
		default:
			return null;
	}
}

function getAlignment(align: string) {
	switch (align) {
		case 'left':
			return 'flex-start';
		case 'right':
			return 'flex-end';
		default:
			return 'center';
	}
}

const Credit = ({ content = '' }: CreditProps) => {
	return (
		<cite
			className={styles['credit']}
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	);
};

interface CreditProps {
	content: string;
}

function isValidUrl(urlString: string) {
	try {
		return Boolean(new URL(urlString));
	} catch (e) {
		return false;
	}
}
